import { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import cn from 'classnames';
import { twMerge } from 'tailwind-merge';
import { SuggestionCandidate } from './typings';

export type MentionListProps = {
  items: SuggestionCandidate[];
  command: (props: { id: string; label: string }) => void;
};
export type MentionListRef = { onKeyDown(props: { event: any }): boolean };

export default forwardRef<MentionListRef, MentionListProps>(function MentionList(props, ref) {
  const [selectedIndex, setSelectedIndex] = useState(0);

  const selectItem = (index: number) => {
    const item = props.items[index];

    if (item) {
      props.command({ id: item.id, label: item.label });
    }
  };

  const upHandler = () => {
    setSelectedIndex((selectedIndex + props.items.length - 1) % props.items.length);
  };

  const downHandler = () => {
    setSelectedIndex((selectedIndex + 1) % props.items.length);
  };

  const enterHandler = () => {
    selectItem(selectedIndex);
  };

  useEffect(() => setSelectedIndex(0), [props.items]);

  useImperativeHandle(ref, () => ({
    onKeyDown: ({ event }: { event: any }) => {
      if (event.key === 'ArrowUp') {
        upHandler();
        return true;
      }

      if (event.key === 'ArrowDown') {
        downHandler();
        return true;
      }

      if (event.key === 'Enter') {
        enterHandler();
        return true;
      }

      return false;
    },
  }));

  return (
    <div className="scaleui scale-theme bg-neutral-0 border rounded flex flex-col gap-2 overflow-auto p-1 relative">
      {props.items.length ? (
        props.items.map((item, index) => (
          <button
            key={index}
            onClick={() => selectItem(index)}
            className={twMerge(
              cn(
                'scaleui scale-theme flex w-full items-center bg-transparent gap-1 rounded p-1 hover:bg-neutral-300',
                {
                  'bg-neutral-200': index === selectedIndex,
                },
              ),
            )}
          >
            {item.label}
          </button>
        ))
      ) : (
        <div className="item">No result</div>
      )}
    </div>
  );
});
